import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../../components/ContactModal";
import {Link} from "react-router-dom";

function Block1() {

    return (
            <section className="about-section-two style-two layout-pt-60 layout-pb-60 js-tab-menu-content">
                <div className="auto-container">
                    <div className="row grid-base align-items-center g-5">
                        <div className="content-column -no-margin col-xl-5 col-lg-6 col-md-12 col-sm-12 wow fadeInRight">
                            <div className="wow fadeInLeft">
                                <div className="sec-title">
                                    <h2 className="fw-700">Un espace d'écoute et d’échange <span>avec nos experts</span></h2>
                                </div>

                                <div className="text mt-30">
                                    Parce qu’<span>un simple échange peut tout changer,</span> les experts Talents Handicap sont là pour répondre de manière <span>confidentielle et personnalisée</span> à tout collaborateur :
                                    <ul className="list-style-two homepage">
                                        <li>ayant des questions sur le handicap au travail</li>
                                        <li>pouvant être en situation de handicap visible ou invisible</li>
                                        <li>aidant d’une personne en situation de handicap</li>
                                    </ul>
                                </div>
                                <Link  to={'/incluvia'} className="theme-btn homepage btn-style-one small mt-3">Espace de démo</Link>
                                {/*<ContactModal textButton="Échangeons sur vos besoins" showText={false} small="small" linkPageContact={false} iframe={false} couleur={false} formModal={true}/>*/}
                            </div>
                        </div>

                        <div className="image-column col-xl-5 offset-xl-2 col-lg-5 offset-lg-1 col-md-12 col-sm-12">
                            <figure className="image-box image-responsive">
                                <img src="/images/resource/discussions.jpg" alt="discussions" className="homepage" />
                            </figure>
                        </div>
                    </div>
                </div>
            </section>
    );
}

export default Block1;
